import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useSearchParams } from '@remix-run/react';
import { useState } from 'react';
import type { ProductsAvailableFilters } from '~/services/api.server';
import type { CategoryNode } from '~/utils/shop';
import type { ProductsGridProps } from './ProductsGrid';
import ProductsGrid from './ProductsGrid';
import ShopCategories from './ShopCategories';
import { FiltersHeader, PriceRangeFilter, PrintMethodsFilter, ProductionTimeFilter } from './common';

type ProductsGridWithFiltersProps = {
  categories: Array<CategoryNode | CategoryNode[]>;
  productsFilters: ProductsAvailableFilters;
  productGridProps: ProductsGridProps;
  isDashboard?: boolean;
};

export default function ProductsGridWithFilters({
  categories,
  productsFilters,
  productGridProps,
  isDashboard = false,
}: ProductsGridWithFiltersProps) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { products } = productGridProps;

  function toggleFiltersOpen() {
    setFiltersOpen((prev) => !prev);
  }

  const [query] = useSearchParams();
  const selectedFiltersCount = [...query].length;

  return (
    <ProductsGrid isDashboard={isDashboard} {...productGridProps}>
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <Button variant="text" onClick={toggleFiltersOpen} startIcon={<FilterListIcon />}>
          Filter {selectedFiltersCount > 0 ? `(${selectedFiltersCount})` : null}
        </Button>
        <Drawer
          open={filtersOpen}
          onClose={toggleFiltersOpen}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { minWidth: '90%' } }}
          sx={{ zIndex: 1300 }}
        >
          <Grid container justifyContent="flex-end" py={1} px={2}>
            <IconButton onClick={toggleFiltersOpen}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <FiltersHeader />
          <Stack py={1} px={2}>
            <PrintMethodsFilter />
            <ShopCategories categories={categories} onNavigate={toggleFiltersOpen} clearSearch={products.count === 0} />
            <PriceRangeFilter minMax={productsFilters.price} />
            <ProductionTimeFilter minMax={productsFilters.production_time} />
          </Stack>
        </Drawer>
      </Box>
    </ProductsGrid>
  );
}
